module.exports = __webpack_public_path__ + "img/Storage=Storage-Off.0eb61488.svg";